<template>
  <el-drawer
    :visible.sync="drawer"
    size="60%"
    direction="btt"
    :withHeader="false"
    :append-to-body="false"
    :modal-append-to-body="false"
  >
    <div class="bot-survey">
      <h1>{{ $t("GPT.SURVEY_DISLIKE.H1") }}</h1>
      <el-row :gutter="20" class="options">
        <el-col
          :span="24"
          :sm="12"
          class="checkbox-group"
          v-for="(o, idx) in surveyCode"
          :key="o.surveyCode"
          :class="{ hide: !o.surveyText || idx == 9 }"
        >
          <input
            type="radio"
            v-model="form.surveyCode"
            :value="o.surveyCode"
            :id="o.surveyCode"
          />
          <label :for="o.surveyCode">
            {{ o.surveyText }}
          </label>
        </el-col>
      </el-row>

      <div class="btns">
        <p>{{ $t("GPT.SURVEY_DISLIKE.P") }}</p>
        <el-button type="primary" :disabled="loading" @click="handleChatLike">{{
          $t("GPT.SURVEY_DISLIKE.BUTTON")
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "bot-survey-code-drawer",
  data() {
    return {
      loading: false,
      drawer: false,
      form: {
        chatBotMessageId: "",
        likeFlag: false,
        surveyCode: "",
      },
    };
  },
  created() {
    this.$bus.$on("openBotSurvey", (id) => {
      this.drawer = true;
      this.form.surveyCode = ""; // reset
      this.form.chatBotMessageId = id;
    });
  },
  methods: {
    async handleChatLike() {
      this.loading = true;
      try {
        await this.$store.dispatch("gpt/handleChatLike", this.form);
        // GA4 按讚
        window.dataLayer.push({
          event: "data_layer_event",
          chatbot_session_id: this.chatbot_session_id,
          event_name_ga4: "dislike_genio",
          event_category_DL: "genio",
          event_action_DL: "clicked",
          event_label_DL: "dislike",
        });
        this.drawer = false;
        this.$bus.$emit("updateIsLike");
      } catch (error) {
        console.log("error", error);
      }
      this.loading = false;
    },
  },
  computed: {
    chatbot_session_id() {
      return this.$store.getters["gpt/chatbot_session_id"];
    },
    surveyCode() {
      const surveyCode = this.$store.state.gpt.surveyCode;
      return surveyCode.filter((el) => {
        return el.surveyText;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bot-survey {
  min-height: 100%;
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  h1 {
    font-size: 16px;
    text-align: center;
    margin-bottom: 32px;
  }
  .options {
    .checkbox-group {
      margin-bottom: 16px;

      input {
        display: none;
      }
      label {
        text-align: center;
        cursor: pointer;
        display: block;
        padding: 8px;
        border-radius: 8px;
        font-size: 14px;
        border: 1px solid #666666;
        color: #666;
      }
      input:checked + label {
        border: 1px solid $primary;
        color: $primary;
      }
    }
    .hide {
      display: none;
    }
  }

  .btns {
    margin-top: auto;
    padding: 0;
    p {
      text-align: center;
      margin: 0;
      margin-bottom: 8px;
      font-size: 12px;
    }
    .el-button {
      width: 100%;
    }
  }
}
</style>
